import $ from 'jquery';
import modal from 'bootstrap';
import {submitForm} from './ajax-form';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// Initialize Ajax Modal
$('body').find('[data-toggle="ajaxModal"]').on('click',
    function(e) {
        $('#ajaxModal').remove();
        e.preventDefault();

        var $this = $(this);
        var $modal = null;
        var $remote = $this.data('remote') || $this.attr('href');
        var formAction = $this.data('action');

        $.get($remote).done(function (response, status) {
            $modal = $(response);
            $modal.submit(submitForm);

            $('body').append($modal);
            $modal.modal({
                keyboard: true
            });

            if (status != "error" && formAction) {
                $modal.find('form').attr('action', formAction);
            }
        });
    }
);



// WEBPACK FOOTER //
// ./resources/js/frontend/modal.js